import React, { useEffect, useRef } from "react";
import { Text3D, useGLTF } from "@react-three/drei";
import {
  useDrawer,
  useSection,
  useSelectObject,
} from "../../../../common/hooks";
import BookContent from "../../../elements/Drawer/contents/BookContent";
import { SECTIONS } from "../../../../constants/sections";
import { whiteMaterial } from "../../../../common/materials";
import { Easing, Tween } from "@tweenjs/tween.js";

const model = "/models/library/book.glb";

export default function Book({
  index,
  color = "orange",
  text,
  scale = [1, 1, 1],
  position,
  textPosition,
  selectBook,
  unselectBook,
  ...props
}) {
  const bookRef = useRef();
  const textRef = useRef();
  const { nodes } = useGLTF(model);
  const { openDrawer } = useDrawer();
  const { currentSection } = useSection();
  const { selectedObject, setSelectedObject } = useSelectObject();

  const font3D = "/fonts/LEMONMILK_Medium_Regular.json";

  const onClick = () => {
    const objectToMove = bookRef.current;
    if (currentSection.name === SECTIONS.LIBRARY) {
      //Unselect previous selected book
      if (selectedObject) {
        unselectBook(selectedObject);
      }
      //If clicked on selected book won't select a new one
      if (selectedObject === objectToMove) setSelectedObject(objectToMove);
      //Select new book
      else {
        setSelectedObject(objectToMove);
        selectBook(objectToMove);
        openDrawer({ content: <BookContent technology={text} /> });
      }
    }
  };

  /* TEXT ANIMATION */
  useEffect(() => {
    if (currentSection.name === SECTIONS.LIBRARY) {
      new Tween(textRef.current)
        .to(
          {
            translateY: 0.5,
            scale: { x: 1, y: 1, z: 1 },
          },
          300
        )
        .easing(Easing.Quadratic.Out)
        .delay(400)
        .start();
    } else {
      new Tween(textRef.current)
        .to(
          {
            translateY: -0.5,
            scale: { x: 0, y: 0, z: 0 },
          },
          300
        )
        .easing(Easing.Quadratic.Out)
        .start();
    }
  }, [currentSection, index]);

  return (
    <group
      name={`book-${text}`}
      position={position}
      rotation={[0, 0, 0]}
      ref={bookRef}
      {...props}
      onClick={onClick}
    >
      <group scale={scale}>
        <mesh castShadow geometry={nodes.Cube011.geometry}>
          <meshToonMaterial attach="material" color={color} />
        </mesh>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube011_1.geometry}
          material={whiteMaterial}
        />
      </group>

      <Text3D
        ref={textRef}
        receiveShadow
        position={[0, 0.25 * scale[1], 0.025].map(
          (num, i) => num + textPosition[i]
        )}
        rotation={[Math.PI, Math.PI / 2, Math.PI / 2]}
        scale={[0, 0, 0]}
        font={font3D}
        size={0.04}
        height={0}
        curveSegments={64}
        material={whiteMaterial}
      >
        {text.toUpperCase()}
      </Text3D>
    </group>
  );
}
